import APP_CONSTANTS from "../constants";

const apiRoute = APP_CONSTANTS.apiUrl + "/api/v4";
const baseUrl = APP_CONSTANTS.apiUrl;

// Auth routes
export const verifyEmailPassAPI = `${apiRoute}/doctor/verify-email-pass`; // for erx
export const loginApiRoute = `${apiRoute}/doctor/loginDoctor`;
export const login = `${apiRoute}/doctor/loginDoctor`;
export const logoutApiRoute = `${apiRoute}/doctor/logoutFromAdmin`;

export const changeVisibilityModeApiRoute = `${apiRoute}/doctor/changeVisibilityMode`;

export const getTodayAssessmentCount = `${apiRoute}/is/tobeassessedtoday/count`;

export const forgotPasswordApiRoute = `${apiRoute}/doctor/forgotPassword`;
export const updatePasswordApiRoute = `${apiRoute}/doctor/updatePassword`;
// export const stateListDoctor = `${apiRoute}/getStateList`; // state list QLD, VIC, ...
export const registerPartOne = `${apiRoute}/doctor/register`; // signup api form 1
export const signUpProfilePicUpload = `${apiRoute}/doctor/uploadImage`; // signup profile pic and photo id upload
export const appConstants = `${apiRoute}/constants`; // get App constants
export const doctorNotifications = `${apiRoute}/doctor/getNotifications`; // get all notifications
export const readDoctorNotification = `${apiRoute}/doctor/readNotification/`; // id needs to be passed at end
export const readAllNotification = `${apiRoute}/doctor/updateNotifications`; //read all notifications
export const clearParticularNotification = `${apiRoute}/doctor/clearParticularNotifications`; //read all notifications
export const getConsultHistoryList = `${apiRoute}/doctor/getConsultHistory`; //get all consult history with pagination (needs to pass params)
export const getConsultHistoryView = `${apiRoute}/doctor/getBookingDetail`; // need to pass booking_id as param booking_id=5e55de5ab2b7500faa18c00d
export const reportConnectionIssue = `${apiRoute}/doctor/consultConnectionIssue`; // need to pass form data - appointmentId: 5e5712ec7aa51f0dc1ce359b & haveConnectionIssue: true
export const getTicketsList = `${apiRoute}/doctor/getTickets`; // need to pass limit=10&skip=0 param
export const getTicketById = `${apiRoute}/admin/getTicketById`; // need to pass ticketId=5e58532e7aa51f0dc1ce3615
export const updateTicket = `${apiRoute}/doctor/editTicket`; // need to pass /5e588a467aa51f0dc1ce3623
export const getBookingList = `${apiRoute}/doctor/getAllBookings`; // need to pass limit=10&skip=0 for open Appointments
export const acceptBookingNo = `${apiRoute}/doctor/acceptBooking`; // need to pass /5d53e3fdf9ab800f762e3970
export const getBankDetailsDoctor = `${apiRoute}/doctor/getBankDetails`;
export const getConsultCostList = `${apiRoute}/doctor/getConsultCosts`;
export const getUserProfile = `${apiRoute}/doctor/getProfile`;
export const updateUserProfile = `${apiRoute}/doctor/editProfile`;
export const getPaymentSummariesList = `${apiRoute}/doctor/getPaymentSummary`; // need to pass params ?endDate=2020-03-04T14:00:00.000Z&limit=5&skip=0&startDate=2020-02-25T14:00:00.000Z
export const getPaymentSummariesListNew = `${apiRoute}/doctor/getPaymentSummarynew`; // used for monthly summary :  need to pass ?endDate=2019-01-31T23:59:00.000Z&startDate=2019-01-01T00:00:00.000Z
export const changePassword = `${apiRoute}/doctor/changePassword`; // need to pass newPassword and oldPassword
export const changePinAPI = `${apiRoute}/doctor/changePin`; // need to pass newPin and oldPin // for ERX
export const getConsultSummaryList = `${apiRoute}/doctor/getConsultSummary`; // need to pass params ?endDate=2020-03-05T14:00:00.000Z&startDate=2020-02-26T14:00:00.000Z
export const getPatientRecordList = `${apiRoute}/pms/searchPatients`; // need to pass params searchParam=janee
export const addBankDetails = `${apiRoute}/doctor/addBankDetails`; // need to pass stripe Id along with other details - please check
export const internetConnectionFileUpload = `${apiRoute}/patient/newUploadImageForTestConnection`; // need to pass file
export const getChatMessageList = `${apiRoute}/doctor/getChatMessages`; // need to pass id as param
export const uploadChatFile = `${apiRoute}/admin/uploadChatFiles`; //need to pass attachments
export const getHomePageData = `${apiRoute}/doctor/getHomePageData`; // home page data like online doctors and queue number
export const acceptConsultRequest = `${apiRoute}/doctor/acceptedConsultRequest`; // after doctor clicks accept on consult request popup
export const changeDoctorBusyState = `${apiRoute}/doctor/changeBusyMode`; // change doctor busy state
export const getBookingDetails = `${apiRoute}/doctor/getBookingDetail`; // need to pass booking_id as param
export const rejectConsultRequest = `${apiRoute}/doctor/rejectedConsultRequest`; // reject consult from patient
export const changeAppointmentStatus = `${apiRoute}/pms/ChangeAppointmentStatus`; // change appointment status hit when user pressed a call button
// export const makeACall = `${apiRoute}/call/makeCall`; // called when user pressed CALL button , right after change appointment status api
export const makeACall = `${apiRoute}/doctor/makeCall`; // called when user pressed CALL button , right after change appointment status api
// export const endTimerPatientCall = `${apiRoute}/call/endTimerPatient`; // first API to end call from doctor
export const endTimerPatientCall = `${apiRoute}/doctor/endTimerPatient`; // first API to end call from doctor
// export const endCallByDoctor = `${apiRoute}/call/endCallByDoctor`; // second API to end call from doctor
export const endCallByDoctor = `${apiRoute}/doctor/endCallByDoctor`; // second API to end call from doctor
export const cancelCallByDoctor = `${apiRoute}/doctor/consult/cancel`;
// export const connectCallApiRoute = `${apiRoute}/call/connectCall`;
export const connectCallApiRoute = `${apiRoute}/doctor/connectCall`; // done in backend-upgrade
export const patientsInQueue = `${apiRoute}/doctor/getPatientsQueue`; // done in backend-upgrade

// export const addBulkBilledIncentiveApiRoute = `${apiRoute}/appointment/addBulkBilledIncentive`; // ? Replaced with appointment/addBulkBilledIncentive
export const addBulkBilledIncentiveApiRoute = `${apiRoute}/doctor/appointment/addBulkBilledIncentive`; // done in backend-upgrade

export const closeVideoCallScreenApiRoute = `${apiRoute}/doctor/closeVideoCallScreen`; // done in backend-upgrade
export const sendSMSToPatientForVideoCallApiRoute = `${apiRoute}/doctor/sendSMSToPatientForVideoCall`; // done in backend-upgrade

// Forum
export const getPostsListApiRoute = `${apiRoute}/forum/getPostsList`;
export const addForumPostApiRoute = `${apiRoute}/forum/addForumPost`;
export const deleteForumPostApiRoute = `${apiRoute}/forum/deleteForumPost`;
export const getUnreadForumPostCount = `${apiRoute}/forum/getUnreadForumPosts`;
export const updateForumCommentCount = `${apiRoute}/forum/post/read/comments`;
export const readForumPostsAPI = `${apiRoute}/forum/readAllForumPosts`;
export const markAllPostsReadApiRoute = `${apiRoute}/forum/post/read/comments/all`; // done in backend-upgrade

export const getPostDetailsApiRoute = `${apiRoute}/forum/getPostDetails`;
export const getPostCommentsApiRoute = `${apiRoute}/forum/getPostComments`;
export const addPostCommentApiRoute = `${apiRoute}/forum/addPostComment`;
export const updatePostCommentApiRoute = `${apiRoute}/forum/updatePostComment`;
export const deletePostCommentApiRoute = `${apiRoute}/forum/deletePostComment`;
export const addPostCommentReplyApiRoute = `${apiRoute}/forum/addPostCommentReply`;
export const updatePostCommentReplyApiRoute = `${apiRoute}/forum/updatePostCommentReply`;
export const deletePostCommentReplyApiRoute = `${apiRoute}/forum/deletePostCommentReply`;
export const medicareConsultCostAPIRoute = `${apiRoute}/admin/getConsultDetailsMedicare`;

/**
 * Instant Switch Routes
 */

// get order history / saved drafts with filters
export const getOrderHistoryAPI = `${apiRoute}/is/orderhistory`;
export const getOrderHistoryWithFilterAPI = `${apiRoute}/is/orderHistoryWithFilter`;

// accept assessment
export const acceptAssessmentAPI = `${apiRoute}/is/doctor/acceptOnlineAssessment`;

// Prescription
export const accessMIMSTokenApiRoute = `${apiRoute}/pms/accessMIMSToken`;
export const mimsEndUserLicenseAgreementApiRoute = `${apiRoute}/mims/v3/end-user-license-agreement`;
export const mimsTermsAndConditionsApiRoute = `${apiRoute}/mims/v3/terms-and-conditions`;
export const getProductsByIngredientApiRoute = `${apiRoute}/pms/getProductsByIngredient`;
export const getProductsByBrandApiRoute = `${apiRoute}/pms/getProductsByBrand`;
export const getDrugProductDetailsByIdApiRoute = `${apiRoute}/pms/getDrugProductDetailsById`;
export const getDrugPBSDetailsByPBSCodeApiRoute = `${apiRoute}/pms/getDrugPBSDetailsByPBSCode`;
export const previouslyPrescribedApiRoute = `${apiRoute}/pms/drug/previousprescribed`; // done in backend-upgrade  //! NOT TESTED YET
export const getPatientByIdApiRoute = `${apiRoute}/pms/getPatientById`; // done in backend-upgrade
export const editPatientProfileApiRoute = `${apiRoute}/pms/editPatientProfile`; // done in backend-upgrade

export const getConsultNoteTemplatesApiRoute = `${apiRoute}/pms/getConsultNoteTemplates`;
export const addConsultNoteTemplateApiRoute = `${apiRoute}/pms/addConsultNoteTemplate`;
export const deleteConsultNoteTemplateApiRoute = `${apiRoute}/pms/deleteConsultNoteTemplate`;

// add consult note routes
export const addConsultNoteStep1ApiRoute = `${apiRoute}/pms/addConsultNoteStep1`;
export const addConsultNoteStep2ApiRoute = `${apiRoute}/pms/addConsultNoteStep2`;

// submit assessment
export const submitOnlineAssessmentAPI = `${apiRoute}/is/doctor/submitOnlineAssessment`;

// instant swtich medicare consult costs
export const instantSwitchMedicareConsultCostAPI = `${apiRoute}/admin/getInstantSwitchConsultDetailsMedicare`;

// instant switch consult costs
export const instantSwitchConsultCostAPI = `${apiRoute}/admin/getInstantSwitchConsultDetails`;
export const instantHushConsultCostAPI = `${apiRoute}/admin/getInstantHushConsultDetails`;

// instant switch medicinal cannabis consult costs
export const instantSwitchMCConsultCostAPI = `${apiRoute}/admin/getInstantSwitchConsultDetailsMedicinalCannabis`;

// change status of online assessment
export const changeOnlineAssessmentStatusAPI = `${apiRoute}/is/changeOnlineAssessmentStatus`;


/**
 * Instant Hush Routes
 */
export const getOrderHistoryInstantHushAPI = `${apiRoute}/ih/orderhistory`;

// accept assessment
export const acceptAssessmentInstantHushAPI = `${apiRoute}/ih/doctor/acceptOnlineAssessment`;

// change status of online assessment
export const ihChangeOnlineAssessmentStatusAPI = `${apiRoute}/ih/changeOnlineAssessmentStatus`;

// submit instant hush assessment
export const submitIHOnlineAssessmentAPI = `${apiRoute}/ih/doctor/submitOnlineAssessment`;

// change opt-in status for ticket sms notificaiton
export const changeOptInStatusTicketSMSAPI = `${apiRoute}/doctor/optional-settings/ticket-sms-notification`;

// Shifts APIs
export const addDoctorShiftAPI = `${apiRoute}/doctor/shift/add`;
export const editDoctorShiftAPI = `${apiRoute}/doctor/shift/edit`;
export const getDoctorShiftsAPI = `${apiRoute}/doctor/shifts`;
export const deleteDoctorShiftAPI = `${apiRoute}/doctor/shift/delete`;

// add note seperately
export const doctorNotes = `${apiRoute}/doctor/ticket/add/doctorNotes`;
export const adminAction = `${apiRoute}/doctor/ticket/note/adminactionrequired`;
export const resolved = `${apiRoute}/doctor/ticket/note/resolved`;

// tags topics list
export const tagsTopicsListAPI = `${apiRoute}/doctor/tags-topics`;
